import React from "react";
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";
import timezoneIcon from "../../../assets/Images/time-zone-48.png";
import { TimeZone } from "../types/authTypes";

interface TimeZoneSelectProps {
  timeZones: TimeZone[];
  value: number | string;
  onChange: (value: number | string) => void;
  loading?: boolean;
}

export const TimeZoneSelect: React.FC<TimeZoneSelectProps> = ({ timeZones, value, onChange, loading = false }) => {
  return (
    <FormControl fullWidth variant="standard" sx={{ m: 2, marginTop: "12px" }}>
      <InputLabel id="timezone-label" style={{ display: "flex", alignItems: "center" }}>
        <img src={timezoneIcon} className="imgs" alt="Time Zone" style={{ width: "24px", height: "24px" }} />
        <span style={{ marginLeft: "10px" }}>Time Zone</span>
      </InputLabel>
      <Select labelId="timezone-label" value={value} onChange={(e) => onChange(e.target.value)} disabled={loading} endAdornment={loading && <CircularProgress size={20} />}>
        {timeZones.map((tz) => (
          <MenuItem key={tz.id} value={tz.id}>
            {`${tz.offset} - ${tz.zone}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
